export const storeList = [
  {
    storeName: 'Belmont',
    phone: '(02) 4945 7000',
    address: '393 Pacific Highway,',
    suburb: 'Belmont 2280',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+393+Pacific+Highway,+Belmont,+2280'
  },
  {
    storeName: 'Cessnock',
    phone: '(02) 4991 9500',
    address: '249 - 255 Vincent Street,',
    suburb: 'Cessnock 2325',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+249+-+255+Vincent+Street,+Cessnock,+2325'
  },
  {
    storeName: 'Erina North',
    phone: '(02) 4365 7300',
    address: '147 The Entrance Road,',
    suburb: 'Erina North 2250',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+147+The+Entrance+Road,+Erina+North,+2250'
  },
  {
    storeName: 'Glendale',
    phone: '(02) 4922 4100',
    address: 'Corner TC Frith Ave and Munibung Road,',
    suburb: 'Boolaroo 2284',
    direction: 'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Lake+Rd,+Boolaro,+2284'
  },
  {
    storeName: 'Heatherbrae',
    phone: '(02) 4988 5500',
    address: '8 Griffin St,',
    suburb: 'Heatherbrae 2324',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+8+Griffin+St,+Heatherbrae,+2324'
  },
  {
    storeName: 'Kotara',
    phone: '(02) 4941 0600',
    address: '30 Northcott Drive,',
    suburb: 'Kotara 2289',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+30+Northcott+Drive,+Kotara,+2289'
  },
  {
    storeName: 'Lake Haven',
    phone: '(02) 4394 4000',
    address: 'Corner Lakehaven Drive & Charmhaven Road,',
    suburb: 'Charmhaven 2263',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+Lakehaven+Drive+%26+Charmhaven+Road,+Charmhaven,+2263'
  },
  {
    storeName: 'Maitland',
    phone: '(02) 4939 1400',
    address: 'Corner New England Highway & Bungaree St,',
    suburb: 'Maitland 2320',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+New+England+Highway+%26+Bungaree+St,+Maitland,+2320'
  },
  {
    storeName: 'Morisset',
    phone: '(02) 4973 9600',
    address: 'Corner Mayfair Close & Advantage Avenue,',
    suburb: 'Morisset 2264',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+Mayfair+Close+%26+Advantage+Avenue,+Morisset,+2264'
  },
  {
    storeName: 'Port Stephens',
    phone: '(02) 4916 3100',
    address: 'Corner Port Stephens Drive & Taylors Beach Road,',
    suburb: 'Taylors Beach 2316',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+Port+Stephens+Drive+%26+Taylors+Beach+Road,+Taylors+Beach,+2316'
  },
  {
    storeName: 'Singleton',
    phone: '(02) 6575 9800',
    address: 'Corner New England Highway & Magpie Street,',
    suburb: 'Singleton 2330',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+New+England+Highway+%26+Magpie+Street,+Singleton,+2330'
  },
  {
    storeName: 'Tuggerah',
    phone: '(02) 4350 1900',
    address: 'Corner Bryant Drive & Wyong Road,',
    suburb: 'Tuggerah 2259',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+Bryant+Drive+%26+Wyong+Road,+Tuggerah,+2259'
  },
  {
    storeName: 'Umina Beach',
    phone: '(02) 4343 2000',
    address: 'Corner West & South Street,',
    suburb: 'Umina Beach 2257',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+West+%26+South+Street,+Umina+Beach,+2257'
  },
  {
    storeName: 'Wallsend',
    phone: '(02) 4941 6400',
    address: 'Corner Sandgate Road & Minmi Road,',
    suburb: 'Wallsend 2287',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+Corner+Sandgate+Road+%26+Minmi+Road,+Wallsend,+2287'
  },
  {
    storeName: 'West Gosford',
    phone: '(02) 4349 3500',
    address: '3 Yallambee Avenue,',
    suburb: 'West Gosford 2250',
    direction:
      'https://www.google.com.au/maps?daddr=Bunnings+Warehouse,+3+Yallambee+Avenue,+West+Gosford,+2250'
  }
];
